import type React from 'react';
import { CostAndFeesContent } from './CostsAndFeesContent';
import { CostsAndFeesContextProvider } from './context/CostsAndFeesProvider';

interface CostAndFeesModalContentProps {
  isWebview?: boolean;
}

/**
 * Content-only wrapper for CostsAndFees modal.
 * Used by ModalContext system which provides its own modal shell.
 * For legacy popup system, use CostsAndFeesModal instead.
 */
const CostAndFeesModalContent: React.FC<CostAndFeesModalContentProps> = ({ isWebview = false }) => {
  return (
    <CostsAndFeesContextProvider>
      <CostAndFeesContent isWebView={isWebview} />
    </CostsAndFeesContextProvider>
  );
};

export default CostAndFeesModalContent;
